import f, { useId as C } from "react";
import N from "classnames";
import { useFormContext as y } from "react-hook-form";
import c from "./checkbox.module.scss.js";
function q({
  label: s,
  name: o,
  isError: p,
  design: r,
  checked: k,
  required: x,
  id: b,
  onChange: a,
  onLabelClick: m,
  formOptions: h = {}
}) {
  const u = b ?? C(), e = y(), l = !!o && !!e, i = l ? !!e.formState.errors[o] : p, n = l && o ? e.register(o, { required: x ? "Required" : !1, ...h }) : {}, v = (t) => {
    l && e.setValue(o, !!t.target.checked), a == null || a(t);
  };
  function d(t) {
    m !== void 0 && (t.preventDefault(), t.stopPropagation(), m(t));
  }
  return /* @__PURE__ */ f.createElement(
    "div",
    {
      "data-testid": "checkbox",
      className: c.container,
      style: {
        "--color": (r == null ? void 0 : r.color) ?? "#f4aaad",
        "--errorColor": (r == null ? void 0 : r.errorColor) ?? "#ea565c",
        "--fontSize": `${(r == null ? void 0 : r.fontSize) ?? 14}px`
      }
    },
    /* @__PURE__ */ f.createElement(
      "input",
      {
        ...n,
        id: u,
        type: "checkbox",
        defaultChecked: k,
        onChange: v,
        className: N(c.checkbox, {
          [c.error]: i
        }),
        "aria-invalid": i ? "true" : void 0
      }
    ),
    /* @__PURE__ */ f.createElement(
      "label",
      {
        htmlFor: u,
        className: c.label,
        onClick: d
      },
      s
    )
  );
}
export {
  q as Checkbox
};
//# sourceMappingURL=Checkbox.js.map
